/**
 * nuqs adapter for React Router v5.
 *
 * nuqs ships adapters for React Router v6/v7, but this project uses v5.
 * This adapter wires nuqs to the native browser History API (replaceState)
 * and listens to popstate for back/forward navigation, matching what the
 * official react-router adapters do under the hood.
 */
import { unstable_createAdapterProvider as createAdapterProvider } from 'nuqs/adapters/custom';
import { useCallback, useEffect, useState } from 'react';

function useReactRouterV5Adapter() {
  const [searchParams, setSearchParams] = useState(
    () => new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search)
  );

  useEffect(() => {
    const onPop = () => setSearchParams(new URLSearchParams(window.location.search));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const updateUrl = useCallback((newSearch, options) => {
    const url = new URL(window.location.href);
    url.search = newSearch.toString();
    const method = options?.history === 'push' ? 'pushState' : 'replaceState';
    window.history[method](window.history.state, '', url.toString());
    setSearchParams(new URLSearchParams(newSearch));
    if (options?.scroll) window.scrollTo(0, 0);
  }, []);

  return { searchParams, updateUrl, autoResetQueueOnUpdate: true };
}

export const NuqsAdapter = createAdapterProvider(useReactRouterV5Adapter);
